import { ActionType, ProTable } from "@ant-design/pro-components";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef, useState } from "react";
import UUIDComponent from "../../components/UUIDComponent";
import { Button, Form, message, Modal, Popconfirm } from "antd";
import GlobalWrap from "../../components/globalWrap";
import { PlusOutlined } from "@ant-design/icons";
import HealthForm from "./HealthForm";
import { useNavigate } from "react-router-dom";

export default function Health() {
    const { jsonRequest } = useGlobalState();
    const navigate = useNavigate();
    const tableRef = useRef<ActionType>();
    const [sceneList, setSceneList] = useState<any[]>([]);
    const [form] = Form.useForm();

    const getSceneList = async () => {
        await jsonRequest.get('/back/daily/heath/scene', {})
            .then((resp: any) => resp.json())
            .then((data: any) => {
                if (data?.code === 0) {
                    setSceneList(data?.data || []);
                } else {
                    message.error(data?.msg || "获取场景列表失败");
                }
            });
    }

    useEffect(() => {
        tableRef.current?.reload();
        getSceneList();
    }, []);

    const columns: any[] = [
        {
            title: "序号",
            valueType: "index",
            search: false,
            align: "center",
        },
        {
            title: "ID",
            dataIndex: "id",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "任务组标题",
            dataIndex: "title",
            align: "center",
            search: false,
        },
        {
            title: "任务组标识",
            dataIndex: "key",
            align: "center",
            search: false,
        },
        {
            title: "备注",
            dataIndex: "remark",
            align: "center",
            search: false,
        },
        {
            title: "循环周期",
            dataIndex: "cyclePeriod",
            align: "center",
            search: false,
            render: (text: number) => text + '天',
        },
        {
            title: "场景名称",
            dataIndex: "sceneName",
            align: "center",
            search: false,
        },
        {
            title: "是否默认任务组",
            dataIndex: "defaultState",
            align: "center",
            search: false,
            render: (text: number) => text ? '是' : '否',
        },
        {
            title: "最小支持版本号",
            dataIndex: "minVersionCode",
            align: "center",
            search: false,
        },
        {
            title: "最大支持版本号",
            dataIndex: "maxVersionCode",
            align: "center",
            search: false,
        },
        {
            title: "创建时间",
            dataIndex: "createAt",
            align: "center",
            search: false,
        },
        {
            title: "操作",
            key: 'operation',
            search: false,
            align: "center",
            render: (_: any, record: any) => <>
                <Button type="link" onClick={() => setTask(record)}>设置</Button>
                <Button type="link" onClick={() => handleAddOrEdit(record)}>编辑</Button>
                <Popconfirm title="确定删除？" okText="是" cancelText="否"
                    onConfirm={() => deleteHandle(record.id)}>
                    <Button type='link' size='small' danger>删除</Button>
                </Popconfirm>
            </>,
        }
    ];
    const setTask = async (record: any) => {
        navigate(`/pulse-diagnosis/health/temp/${record.id}`);
    }

    const handleAddOrEdit = (item: any) => {
        Modal.confirm({
            width: 600,
            title: !!item.id ? `任务组编辑 - ${item.title}` : "任务组新增",
            content: <GlobalWrap><HealthForm form={form} item={item} sceneList={sceneList} /></GlobalWrap>,
            onOk: async (close) => {
                let values = await form.validateFields();
                if (item?.id) {
                    values.id = item.id;
                }
                await jsonRequest.post("/back/daily/heath/task", {
                    ...values,
                }).then((resp: any) => resp.json())
                    .then((data: any) => {
                        if (data?.code === 0) {
                            message.success(`${!!item.id ? "编辑" : "新增"}成功`);
                        } else {
                            message.error(data?.msg || `${!!item.id ? "编辑" : "新增"}失败`);
                        }
                    }
                    )
                tableRef.current?.reload();
                form.resetFields();
                close();
                return false;
            },
            onCancel: (close) => {
                form.resetFields();
                close();
            }
        })
    }

    const deleteHandle = async (id: any) => {
        const result: any = await jsonRequest.delete(`/back/daily/heath/task/${id}`, {});
        if (result?.body.code === 0)
            message.success('删除成功');
        else {
            message.error('删除失败');
            console.log(result);
        }
        tableRef.current?.reload();
    }

    const request = async (params: any) => {
        const result: any = await jsonRequest.get("/back/daily/heath/page/task", {
            currentPage: params.current,
            pageSize: params.pageSize,
        }).then((resp: any) => resp.json());
        const { data } = result;
        return { data: data?.data, success: result.code === 0, total: data?.count };
    };

    return <>
        <h1>任务组列表</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 100 }}
            actionRef={tableRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false }}
            toolBarRender={() => [<Button
                key="button"
                icon={<PlusOutlined />}
                onClick={() => handleAddOrEdit({})}
                type="primary"
            >
                新增
            </Button>]}
        />
    </>;
}